import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_FAILURE
} from '../constants'

export function* getBrandsDataMasterSaga() {
  try {
      
      const result =  yield call(BFFAgent.Datamasters.getBrands)
      const brandsList = result?.data?.data

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_SUCCESS,
          data: brandsList
      })
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
